import ExcelJS from "exceljs";
import { saveAs } from 'file-saver';
import ExcelData from '../excelData.js'; // 使用excelData.js中的函数

// 主要的Excel导出类
class ExcelExporter {
  // 导出项目数据到Excel
  static async exportProject(projectData, toast, chartData = {}) {
    try {
      // 清理数据以防止equivalentTo错误
      const cleanProjectData = ExcelData.cleanDataForExcel(projectData);
      const projectName = cleanProjectData?.projectName || "export";

      // 创建ExcelJS工作簿
      const wb = new ExcelJS.Workbook();
      
      // 按照用户指定的顺序导出所有表格
      ExcelData.exportProjectParams(cleanProjectData, wb);          // 项目参数表
      ExcelData.exportInvestmentEstimate(cleanProjectData, wb);     // 总投资估算表
      ExcelData.exportConstructionCost(cleanProjectData, wb);       // 建筑工程费用估算表
      ExcelData.exportEquipmentCost(cleanProjectData, wb);          // 设备工程费用估算表
      ExcelData.exportOtherCosts(cleanProjectData, wb);             // 工程建设其他费用估算表
      ExcelData.exportWorkingCapitalEstimate(cleanProjectData, wb); // 流动资金估算表
      ExcelData.exportFundingPlan(cleanProjectData, wb);            // 资金筹措表
      ExcelData.exportAnnualInvestmentPlan(cleanProjectData, wb);   // 分年投资计划表
      ExcelData.exportRepayment(cleanProjectData, wb);              // 借款还本付息表
      ExcelData.exportTotalCost(cleanProjectData, wb);              // 总成本费用估算表
      ExcelData.exportRawMaterials(cleanProjectData, wb);           // 原辅材料费用估算表
      ExcelData.exportFuelPower(cleanProjectData, wb);              // 燃料动力费用估算表
      ExcelData.exportWelfare(cleanProjectData, wb);                // 工资福利费用估算表
      ExcelData.exportDepreciation(cleanProjectData, wb);           // 固定资产折旧费用估算表
      ExcelData.exportAmortization(cleanProjectData, wb);           // 其他资产摊销费用估算表
      ExcelData.exportRevenueTaxSummary(cleanProjectData, wb);      // 营业收入及税金估算表
      ExcelData.exportProfit(cleanProjectData, wb);                 // 利润表
      ExcelData.exportAllInvestmentCashFlow(cleanProjectData, wb);  // 全部投资现金流量表
      ExcelData.exportCapitalCashFlow(cleanProjectData, wb);        // 资本金现金流量表
      ExcelData.exportFinancialPlanCashFlow(cleanProjectData, wb);  // 财务计划现金流量表
      ExcelData.exportBreakevenAnalysis(cleanProjectData, wb);      // 盈亏平衡分析表
      ExcelData.exportSensitivityAnalysis(cleanProjectData, wb);    // 敏感性分析表
      ExcelData.exportSensitivityCoeffTable(cleanProjectData, wb);  // 敏感度系数和临界点分析表
      
      // 导出图表 - 无论是否有图表实例都创建工作表
      console.log("开始导出图表");
      
      // 总是创建盈亏平衡分析图表工作表
      try {
        console.log("创建盈亏平衡分析图表工作表");
        await ExcelData.exportBreakevenChart(cleanProjectData, wb, chartData.breakevenChart, chartData.breakevenChartBase64); // 盈亏平衡分析图
        console.log("成功创建盈亏平衡分析图表工作表");
      } catch (error) {
        console.error("创建盈亏平衡分析图表工作表失败:", error);
      }
      
      // 总是创建敏感性分析图表工作表
      try {
        console.log("创建敏感性分析图表工作表");
        await ExcelData.exportSensitivityChart(cleanProjectData, wb, chartData.sensitivityChart, chartData.sensitivityChartBase64); // 敏感性分析图
        console.log("成功创建敏感性分析图表工作表");
      } catch (error) {
        console.error("创建敏感性分析图表工作表失败:", error);
      }
      
      console.log("图表导出处理完成");
      
      // 生成Excel文件
      const buffer = await wb.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      saveAs(blob, `${projectName}.xlsx`);

      if (toast) {
        toast.success("导出成功");
      }

      return true;
    } catch (error) {
      console.error("导出失败:", error);
      if (toast) {
        toast.error("导出失败：" + error.message);
      }
      return false;
    }
  }
}

export default ExcelExporter;